import { create } from 'zustand'

interface ReviewModalState {
  isOpen: boolean
  open: () => void
  close: () => void
}

const useReviewModal = create<ReviewModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))

export default useReviewModal
